module.exports = {"632221100":"浩门镇","632221101":"青石咀镇","632221102":"泉口镇","632221103":"东川镇","632221200":"北山乡","632221201":"麻莲乡","632221202":"西滩乡","632221203":"阴田乡","632221204":"仙米乡","632221205":"珠固乡","632221206":"苏吉滩乡","632221207":"皇城蒙古族乡","632221400":"门源监狱","632221401":"门源种马场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632221.json
// module id = 3132
// module chunks = 0